<script>
export default {
  name: 'DataCell',
  functional: true,
  props: {
    cellData: {
      type: Object,
      required: true
    },
    nonWorkingCells: {
      type: Set,
      default: () => new Set()
    },
    endDayHour: {
      type: Number,
      default: 16
    },
    cellDurationMinutes: {
      type: Number,
      default: 15
    }
  },
  render(h, { props }) {
    const { cellData, nonWorkingCells, endDayHour, cellDurationMinutes } = props;
    const userId = cellData.groups?.default_user_id;
    let isNonWorking = false;
    let isEndOfDay = false;

    const d = cellData.startDate;
    const cellHour = d.getHours() + (d.getMinutes() / 60);
    const lastSlotHour = endDayHour - (cellDurationMinutes / 60);
    isEndOfDay = cellHour === lastSlotHour;

    if (userId) {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      isNonWorking = nonWorkingCells.has(`${userId}|${year}-${month}-${day}|${cellHour}`);
    }

    return h('div', {
      class: ['data-cell-wrapper', { 'non-working-timeslot': isNonWorking }],
      attrs: isEndOfDay ? { 'data-eod': '1' } : {},
      style: { width: '100%', height: '100%', position: 'relative' }
    });
  }
};
</script>